import { render, staticRenderFns } from "./PageBlog.vue?vue&type=template&id=066cce36&"
import script from "./PageBlog.vue?vue&type=script&lang=js&"
export * from "./PageBlog.vue?vue&type=script&lang=js&"
import style0 from "./PageBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports